module.exports = __webpack_public_path__ + "static/Blog@0.25x-c779db9af467c8e45fbfa9cd9633249a.png";